import { render, staticRenderFns } from "./BrowsingHistory.vue?vue&type=template&id=1ca588f5&scoped=true"
import script from "./BrowsingHistory.vue?vue&type=script&lang=js"
export * from "./BrowsingHistory.vue?vue&type=script&lang=js"
import style0 from "./BrowsingHistory.vue?vue&type=style&index=0&id=1ca588f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca588f5",
  null
  
)

export default component.exports